import { Pipe, PipeTransform } from '@angular/core';
import { ItemForDisplay } from '../../models';

@Pipe({
  name: 'addToCartDisabled',
  standalone: true,
  pure: true,
})
export class AddToCartDisabledPipe implements PipeTransform {
  transform(item: ItemForDisplay): boolean {
    return item.HidePrice || item.AvailableQuantity <= 0;
  }
}
